/** Pick the section whose heading has most recently crossed under the sticky dock. */
export function pickActiveSectionId<T extends string>(
  sections: ReadonlyArray<{ id: T; top: number }>,
  dockBottom: number,
  threshold = 24,
): T | null {
  const line = dockBottom + threshold;
  let bestId: T | null = null;
  let bestTop = Number.NEGATIVE_INFINITY;

  for (const section of sections) {
    if (section.top <= line && section.top > bestTop) {
      bestTop = section.top;
      bestId = section.id;
    }
  }

  if (bestId !== null) return bestId;

  let nearestId: T | null = null;
  let nearestDistance = Number.POSITIVE_INFINITY;
  for (const section of sections) {
    const distance = Math.abs(section.top - line);
    if (distance < nearestDistance) {
      nearestDistance = distance;
      nearestId = section.id;
    }
  }

  return nearestId;
}
